import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import * as MapVesselUtil from "@/utils/MapVesselUtil";
import { storageWebCam, db } from "@/firebase/firebaseConfig";
const evApi = AiseaApiFactory.get("enterpriseVessel");
const evpApi = AiseaApiFactory.get("enterpriseVesselPicture");
const evdApi = AiseaApiFactory.get("enterpriseVesselDocument");
const evhApi = AiseaApiFactory.get("enterpriseVoyageHistories");
const picApi = AiseaApiFactory.get("picture");
const cApi = AiseaApiFactory.get("constant");
const vHisApi = AiseaApiFactory.get("voyageHistory");
const vApi = AiseaApiFactory.get("voyage");
const sdfApi = AiseaApiFactory.get("enterpriseVesselSecureDataflowChannel");
const recordApi = AiseaApiFactory.get("enterpriseVoyageRecords");

import { DateUtil, WakeLineUtil } from "@/utils";
import moment from "moment-timezone";

export default {
  async setMode({ commit }, mode) {
    commit("SET_MODE", mode);
  },
  async setMapStyle({ commit }, style) {
    commit("SET_MAP_STYLE", style);
  },
  /*=========================================================================================
   船舶基本情報系
  ==========================================================================================*/
  async fetchVesselGeneralInfo({ commit }, vesselId) {
    let resCountryCode = await cApi.fetchCountryCode();
    commit("SET_COUNTRY_CODE", resCountryCode.data.country_codes);
    let resVessel = await evApi.fetchVessel(vesselId);
    commit("SET_VESSEL", resVessel.data);
    let resPicture = await evpApi.fetch(vesselId);
    commit("SET_VESSEL_PICTURES", resPicture.data);
  },

  async disableVessel({ commit }, vesselId) {
    await evApi.disable(vesselId);
    let resVessel = await evApi.fetchVessel(vesselId);
    commit("SET_VESSEL", resVessel.data);
  },

  async enableVessel({ commit }, vesselId) {
    await evApi.enable(vesselId);
    let resVessel = await evApi.fetchVessel(vesselId);
    commit("SET_VESSEL", resVessel.data);
  },

  /*=========================================================================================
   カメラ系
  ==========================================================================================*/
  async fetchCameras(_, vesselId) {
    let res = await evApi.fetchCameras(vesselId);
    return res.data.cameras;
  },

  async fetchVesselVoyageHistoryCameraUrls(_, payload) {
    let historyDateUtc = DateUtil.toMomentObj(payload.startTime).utc();
    let targetDateUtc = historyDateUtc.format("YYYY-MM-DDTHH:mm:ss");
    let dateSplit = targetDateUtc.split("T");
    let date = dateSplit[0].split("-").join("");
    let time = dateSplit[1].split(":");
    let hh = time[0];
    let mm = time[1];

    historyDateUtc = DateUtil.toMomentObj(targetDateUtc);

    let videoSrc = await storageWebCam
      .child(`${payload.hash}/${date}/${hh}`)
      .list();

    if (videoSrc.items.length === 0) {
      return false;
    }

    let targetVideoSrcUrls = [];
    videoSrc.items.forEach(v => {
      targetVideoSrcUrls.push({
        src: `${process.env.VUE_APP_FIRESOTRAGE_WEBCAM_URL}${v.location.path}`,
        type: "video/mp4",
      });
    });

    targetVideoSrcUrls.forEach(v => {
      let srcTime = v.src.slice(-24).slice(0, 14);
      let year = srcTime.slice(0, 4);
      let man = srcTime.slice(4, 6);
      let day = srcTime.slice(6, 9);
      let hh = srcTime.slice(10, 12);
      let mm = srcTime.slice(-2);
      let videoStartTime = DateUtil.toMomentObj(
        `${year}-${man}${day}T${hh}:${mm}:00`
      );
      v["startTime"] = videoStartTime.format("YYYY-MM-DDTHH:mm:ss");
      v["endTime"] = DateUtil.addTime(videoStartTime, 10, "m").format(
        "YYYY-MM-DDTHH:mm:ss"
      );
      v["historyDate"] = historyDateUtc.format("YYYY-MM-DDTHH:mm:ss");
    });

    let from = null;
    let to = null;

    if (mm === "30") {
      from = DateUtil.addTime(targetDateUtc, -10, "m");
      to = DateUtil.addTime(from, 40, "m");
    } else {
      from = DateUtil.toMomentObj(targetDateUtc);
      to = DateUtil.addTime(from, 30, "m");
    }

    // 対象時間だけフィルター
    let videoSrcUrls = targetVideoSrcUrls.filter(v => {
      return DateUtil.isBetween(DateUtil.toMomentObj(v["startTime"]), from, to);
    });

    // 日付またぎ
    if (hh === "00" && mm === "00") {
      let preDay = DateUtil.addTime(dateSplit[0], -1, "d").format();
      date = preDay
        .split("-")
        .join("")
        .split("T")[0];
    } else if (hh === "23" && mm === "30") {
      let nextDay = DateUtil.addTime(dateSplit[0], 1, "d").format();
      date = nextDay
        .split("-")
        .join("")
        .split("T")[0];
    }

    // 分またぎ
    if (mm === "00") {
      let preHh = "";
      if ("0" === hh.substr(0, 1)) {
        let h = hh.substr(1, 1);
        let preH = Number(h) - 1;
        preHh = ("00" + preH).slice(-2);
      } else {
        preHh = String(Number(hh) - 1);
      }
      let preVideoSrc = await storageWebCam
        .child(`${payload.hash}/${date}/${preHh}`)
        .list();
      let preVideoSrcUrls = [];
      preVideoSrc.items.forEach(v => {
        let srcTime = v.location.path.slice(-24).slice(0, 14);
        let year = srcTime.slice(0, 4);
        let man = srcTime.slice(4, 6);
        let day = srcTime.slice(6, 9);
        let hh = srcTime.slice(10, 12);
        let mm = srcTime.slice(-2);
        let videoStartTime = DateUtil.toMomentObj(
          `${year}-${man}${day}T${hh}:${mm}:00`
        );
        preVideoSrcUrls.push({
          src: `${process.env.VUE_APP_FIRESOTRAGE_WEBCAM_URL}${v.location.path}`,
          type: "video/mp4",
          startTime: videoStartTime.format("YYYY-MM-DDTHH:mm:ss"),
          endTime: DateUtil.addTime(videoStartTime, 10, "m").format(
            "YYYY-MM-DDTHH:mm:ss"
          ),
          historyDate: historyDateUtc.format("YYYY-MM-DDTHH:mm:ss"),
        });
      });
      videoSrcUrls.unshift(preVideoSrcUrls[preVideoSrcUrls.length - 1]);
    } else if (mm === "30" && videoSrcUrls.length !== 4) {
      let nextHh = "";
      if ("0" === hh.substr(0, 1)) {
        let h = hh.substr(1, 1);
        let nextH = Number(h) + 1;
        nextHh = ("00" + nextH).slice(-2);
      } else {
        nextHh = String(Number(hh) + 1);
      }
      let nextVideoSrc = await storageWebCam
        .child(`${payload.hash}/${date}/${nextHh}`)
        .list();
      let nextVideoSrcUrls = [];
      nextVideoSrc.items.forEach(v => {
        let srcTime = v.location.path.slice(-24).slice(0, 14);
        let year = srcTime.slice(0, 4);
        let man = srcTime.slice(4, 6);
        let day = srcTime.slice(6, 9);
        let hh = srcTime.slice(10, 12);
        let mm = srcTime.slice(-2);
        let videoStartTime = DateUtil.toMomentObj(
          `${year}-${man}${day}T${hh}:${mm}:00`
        );
        nextVideoSrcUrls.push({
          src: `${process.env.VUE_APP_FIRESOTRAGE_WEBCAM_URL}${v.location.path}`,
          type: "video/mp4",
          startTime: videoStartTime.format("YYYY-MM-DDTHH:mm:ss"),
          endTime: DateUtil.addTime(videoStartTime, 10, "m").format(
            "YYYY-MM-DDTHH:mm:ss"
          ),
          historyDate: historyDateUtc.format("YYYY-MM-DDTHH:mm:ss"),
        });
      });
      videoSrcUrls.push(nextVideoSrcUrls[0]);
    }

    videoSrcUrls.forEach(v => {
      let startDiff = DateUtil.diff(v.startTime, v.historyDate, "seconds");
      v["startDiff"] = startDiff;
    });

    return videoSrcUrls;
  },

  /*=========================================================================================
   Live系
  ==========================================================================================*/
  async setVesselLivePosition({ commit }, payload) {
    commit("SET_VESSEL_LIVE_POSITION", payload);
  },

  async setVesselLiveAisInfo({ commit }, payload) {
    commit("SET_VESSEL_LIVE_AIS_INFO", payload);
  },

  async fetchWakeLine(_, payload) {
    const prams = {
      started_at:
        moment()
          .utc()
          .subtract(1, "days")
          .format("YYYY-MM-DDTHH:mm:ss.000") + "Z",
      ended_at:
        moment()
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.000") + "Z",
      vesselId: payload.vesselId,
    };
    try {
      let res = await recordApi.fetchWakeByVesselId(prams);
      if (res.data) {
        let positions = res.data.p;
        // coordinateは最低2以上必要なので無い場合は作成しない
        if (positions.length <= 1) {
          return [];
        }
        // 重複データ削除
        let filterPositions = positions.filter(function(v1, i1, a1) {
          return (
            a1.findIndex(v2 => {
              return v1.d === v2.d;
            }) === i1
          );
        });
        // ソート
        filterPositions.sort((a, b) => {
          return a.d > b.d ? 1 : -1;
        });
        // 速さによる色つけ
        let positionWithColor = [];
        filterPositions.forEach(p => {
          p["vesselName"] = payload.vesselName;
          p["localDate"] = moment
            .utc(p.d)
            .local()
            .format("YYYY/MM/DD HH:mm");
          p["color"] = WakeLineUtil.getVelocityColor(p.v);
          p["opacity"] = 0.9;
          positionWithColor.push(p);
        });
        return positionWithColor;
      } else {
        return [];
      }
    } catch (e) {
      return [];
    }
  },

  async crateWakeLineFeatureCollection(_, wakes) {
    let features = WakeLineUtil.crateWakeLineFeature(wakes);
    return MapVesselUtil.createFeatureCollection(features);
  },

  async crateLiveVesselsFeatureCollections(_, payload) {
    let pointFeatures = [];
    let polygonFeatures = [];
    let vectorFeatures = [];
    let symbolFeatureCollection;
    let polygonFeatureCollection;
    let vectorFeatureCollection;

    let vesselId = payload.vesselId;
    let position = payload.position;
    let ais = payload.ais;
    let pointFeature = MapVesselUtil.createPointFeature(
      vesselId,
      position,
      ais,
      DateUtil.currentEpochSeconds(),
      false,
      true,
      false
    );
    pointFeatures.push(pointFeature);
    symbolFeatureCollection = MapVesselUtil.createFeatureCollection(
      pointFeatures
    );

    let polygonFeature = MapVesselUtil.createPolygonFeature(
      vesselId,
      position,
      ais
    );
    if (polygonFeature.length !== 0) {
      polygonFeatures = polygonFeatures.concat(polygonFeature);
    }
    if (polygonFeatures.length !== 0) {
      polygonFeatureCollection = MapVesselUtil.createFeatureCollection(
        polygonFeatures
      );
    }

    let vectorFeature = MapVesselUtil.createVectorFeature(
      vesselId,
      position,
      ais,
      5
    );
    vectorFeatures.push(vectorFeature);
    vectorFeatureCollection = MapVesselUtil.createFeatureCollection(
      vectorFeatures
    );

    return {
      symbolFeatureCollection: symbolFeatureCollection,
      vectorFeatureCollection: vectorFeatureCollection,
      polygonFeatureCollection: polygonFeatureCollection,
    };
  },

  async setVesselPositionExpired10min({ commit }, isExpired) {
    commit("SET_VESSEL_POSITION_EXPIRED_10MIN", isExpired);
  },

  async getLastVesselPosition(_, vesselId) {
    let res = await vHisApi.getLastPosition(vesselId);
    return res.data;
  },

  /*=========================================================================================
    航海履歴系
   ==========================================================================================*/
  async setVoyageHistoryDateTime({ commit }, payload) {
    commit("SET_VOYAGE_HISTORY_DATE_TIME", payload);
  },

  async fetchVoyageHistories({ commit }, payload) {
    let res = await evhApi.fetch(payload);
    commit("SET_VOYAGE_HISTORIES", res.data.summaries);
    return res.data.summaries;
  },

  async fetchVoyageHistoryDetail(_, voyageHistoryId) {
    let res = await vApi.fetchVoyageHistoryDetail(voyageHistoryId);
    return res.data;
  },

  /*=========================================================================================
    船舶書類系
   ==========================================================================================*/
  async fetchDocuments({ commit }, vesselId) {
    const payload = {
      limit: 9999,
    };
    let res = await evdApi.fetchEnterpriseVesselDocuments(vesselId, payload);
    commit("SET_DOCUMENTS_LIST", { documentsList: res.data });
    return true;
  },

  // eslint-disable-next-line no-unused-vars
  async addDocuments({ commit }, payload) {
    let formData = new FormData();
    formData.append("data", payload.file);
    let resPicture = await picApi.addVesselDocumentPicture({
      formData: formData,
    });

    await evdApi.add(payload.vesselId, {
      document_name: payload.name,
      picture_id: resPicture.data.id,
    });

    await new Promise(resolve => setTimeout(resolve, 2000));

    return true;
  },

  // eslint-disable-next-line no-unused-vars
  async updateDocument({ commit }, payload) {
    await evdApi.update(payload.vesselId, payload.linkId, payload.request);
    return true;
  },

  /*=========================================================================================
   初期化
  ==========================================================================================*/
  async resetEnterpriseVesselViewState({ commit }) {
    let defaultState = {
      vessel: null,
      mode: "live",
      vesselLivePosition: null,
      vesselLiveAisInfo: null,
      vesselPictures: null,
      countryCodes: [],
      cameraSelectOptions: [],
      documentsList: null,
      voyageHistories: [],
      voyageHistoryDateTime: null,
      mapStyle: null,
      vesselPositionExpired10min: false,
    };
    commit("RESET_STATE", defaultState);
  },

  // Firestore を取得
  async fetchVesselLiveDataFirestore({ commit, state }, payload) {
    const enterpriseId = "e:" + payload.enterpriseId;
    const vesselId = "v:" + payload.vesselId;

    const collectionRef = db
      .collection("enterprise_vessel_dashboard")
      .doc(enterpriseId)
      .collection(vesselId)
      .doc("vessel_dashboard")
      .collection("data");
    const snapshot = await collectionRef.get();
    commit("CLEAR_VESSEL_LIVE_DATA", payload);
    snapshot.forEach(doc => {
      let data = doc.data();
      let payload = {
        vesselLiveData: data,
      };
      commit("SET_VESSEL_LIVE_DATA", payload);
    });
    return state.vesselLiveData;
  },

  async getVersion(_, payload) {
    let params = {
      kind: payload.kind,
      origin: payload.origin,
      vessel_id: payload.vesselId,
    };
    return await sdfApi.getChannelVersions(payload.vesselId, params);
  },

  async getChannelUnit(_, payload) {
    let params = {
      keyword: payload.keyword,
      limit: 1,
      version_id: payload.versionId,
    };
    return await sdfApi.searchChannels(payload.vesselId, params);
  },

  async subscribeChannelDataFirestore({ commit }, subscribeList) {
    for (let index = 0; index < subscribeList.length; index++) {
      let subscribeObj = await db
        .collection("vessel_channel_data")
        .doc(`v_${subscribeList[index]["vesselId"]}`)
        .collection(`${subscribeList[index]["kind"]}`)
        .doc(`${subscribeList[index]["versionName"]}`)
        .collection("data")
        .doc(`${subscribeList[index]["channelId"]}`)
        .onSnapshot(doc => {
          let data = doc.data();
          let payload = {
            versionName: subscribeList[index]["versionName"],
            kind: subscribeList[index]["kind"],
            channelId: data.ch,
            value: data.vn !== null ? data.vn : data.vs,
          };
          commit("UPDATE_LIVE_DATA_VALUE_MAP", payload);
        });
      commit("ADD_FIRESTORE_SUBSCRIBE_LIST", subscribeObj);
    }
  },

  async unsubscribeChannelDataFirestore({ commit }) {
    commit("UNSUBSCRIBE_FIRESTORE");
  },

  async updateVersionMap({ commit }, payload) {
    commit("SET_KIND_ORIGIN_VERSION_MAP", payload);
  },

  async updateChannelUnitMap({ commit }, payload) {
    commit("SET_CHANNEL_UNIT_MAP", payload);
  },
};
